import axios from "axios";
import { baseURL } from "../utils/URL";

const ongetOrgWeekends = async (organizationID: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/weekend/organization/${organizationID}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const ongetOrgHolidays = async (organizationID: any, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/holiday/organization/${organizationID}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const onAddWeekend = async (postData: any, config: any) => {
  try {
    const response = await axios.post(`${baseURL}/weekend`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onAddHoliday = async (postData: any, config: any) => {
  try {
    const response = await axios.post(`${baseURL}/holiday`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onDeleteWeekend = async (
  organizationID: any,
  id: any,
 
  config: any
) => {
  try {
    const response = await axios.delete(
      `${baseURL}/weekend/organization/${organizationID}/weekend/${id}`,config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

export { ongetOrgWeekends,ongetOrgHolidays,onAddHoliday, onAddWeekend ,onDeleteWeekend};
